/**
 * EchoToggle — ECHO 톤 슬림 토글 (공용)
 *
 * 기존 토글(48×28, 그림자 진함, 그라데이션)보다 얇고 가벼운 요즘 스타일.
 * 알림톡 설정 · 복습 설정 · Dictation 등 모든 토글이 이걸 씁니다.
 *
 * Props:
 *   checked   : boolean
 *   onChange  : () => void
 *   disabled  : boolean (선택)
 *   size      : "sm" | "md"  (기본 md)
 */
const EchoToggle = ({ checked, onChange, disabled = false, size = "md" }) => {
  const dim =
    size === "sm"
      ? { w: 36, h: 20, knob: 14, pad: 3 }
      : { w: 42, h: 24, knob: 18, pad: 3 };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => !disabled && onChange()}
      style={{
        width: `${dim.w}px`,
        height: `${dim.h}px`,
        borderRadius: "999px",
        border: "none",
        padding: 0,
        backgroundColor: checked ? "#00D9C0" : "#DDE4E3",
        position: "relative",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.45 : 1,
        transition: "background-color .18s ease",
        flexShrink: 0,
        display: "block",
      }}
    >
      <span
        style={{
          position: "absolute",
          top: `${dim.pad}px`,
          left: checked ? `${dim.w - dim.knob - dim.pad}px` : `${dim.pad}px`,
          width: `${dim.knob}px`,
          height: `${dim.knob}px`,
          borderRadius: "50%",
          backgroundColor: "#FFF",
          boxShadow: "0 1px 2px rgba(14,20,27,.16)",
          transition: "left .18s cubic-bezier(.4,0,.2,1)",
        }}
      />
    </button>
  );
};

export default EchoToggle;
